define(function ( require ) {
    'use strict';

    var _ = require('underscore');
    var Backbone = require('backbone');
    var Marionette = require('marionette');

    var missedCallsTpl = require('text!tmpls/parts/caller/missed-calls.tpl').default;
    var missedCallsListTpl = require('text!tmpls/parts/caller/missed-calls-list.tpl').default;
    var audioPlayerTpl = require('text!tmpls/parts/caller/audio-player.tpl').default;

    var EmptyView = require('parts/rightbar_empty');
    var PopoverBehavior = require('behaviors/popover');
    var ModalBehavior = require('behaviors/modal');
    var AppConfig = require('config/application');
    var SmsEditPopover = require('popovers/sms_edit/view');
    var StaffCallContactPopover = require('popovers/staff_call_to_contact/view');
    var PopoversFactory = require('popovers/factory');
    var audiojs = require('audiojs').audiojs;

    var MissedCallsList = Marionette.ItemView.extend({
        template: missedCallsListTpl,
        className: 'b-mc__body scrollbar-macosx',

        initialize: function ( options ) {
            this.model = new Backbone.Model({
                items: options.items
            });
        }
    });

    var AudioPlayer = Marionette.ItemView.extend({
        template: audioPlayerTpl,

        ui: {
            'audio': '#js-audio-tag__missed-call'
        },

        initialize: function () {
            this.listenTo(this.model, 'playPause', this.onPlayPause);
        },

        onRender: function () {
            this.player = audiojs.create(this.ui.audio, {
                autoplay: false
            });
        },

        onPlayPause: function ( playPauseBtn ) {
            this.player[0].playPause();
            var isPlay = this.player[0].playing;

            isPlay ?
                playPauseBtn.addClass('play') :
                playPauseBtn.removeClass('play');
        }

    });

    return Marionette.LayoutView.extend({
        template: missedCallsTpl,

        ui: {
            'deleteCall': '.js-delete-call',
            'collapseProject': '.js-collapse-project',
            'singleProject': '.js-single-project',
            'allProjects': '.js-all-projects',
            'missedItem': '.js-missed-item',
            'activateCheckbox': '#b-auto-call__activate',
            'slideWrap': '.b-auto-call__slide-wrap',
            'callBtn': '.js-contact-phone-call',
            'smsBtn': '.js-contact-sendsms',
            'call_btn_mobile': '.call_btn_mobile',
            'btnSendSms': '.btn_send_sms',
            'getWelcomeSongBtn': '.js-get-welcome-song',
            'audio': '#js-audio-tag__missed-call',
            'audioPlayPause': '.js-play-welcome-song',
            'blockAutoCall': '.b-auto-call',
            'toggleAutoCall': '.js-toggle-auto-call',
            'missedCallsRegion': '.js-region-missed-calls'
        },

        events: {
            'click @ui.deleteCall': 'deleteCall',
            'click @ui.collapseProject': 'collapseProject',
            'click @ui.singleProject': 'singleProject',
            'click @ui.allProjects': 'allProjects',
            'click @ui.toggleAutoCall': 'toggleCheckboxAutoCall',
            'change @ui.activateCheckbox': 'toggleCheckboxAutoCall',
            'mousedown  @ui.callBtn': 'onPressPhoneCall',
            'click @ui.smsBtn': 'onClickSendSms',
            'click @ui.call_btn_mobile': 'callMobile',
            'click @ui.btnSendSms': 'sendSmsToPhone',
            'click @ui.audioPlayPause': 'audioPlayPause'

        },

        regions: {
            'regionMissedCalls': '.js-region-missed-calls',
            'regionAudioPlay': '.js-region-audio-play'
        },

        behaviors: {
            'popover': {
                behaviorClass: PopoverBehavior
            },
            'modal': {
                behaviorClass: ModalBehavior
            }
        },

        initialize: function () {
            var that = this;
            this.listenTo(this.collection, 'sync', this.transform_collection);
            this.listenTo(
                this.model,
                'change:is_active change:attempts_count change:interval_min change:greeting',
                _.debounce(that.modelSave, 500)
            );
            Backbone.Validation.bind(this, {
                model: this.model
            });
            this.listenTo(this.model, 'validated:invalid', this._showError);
            this.listenTo(this.model, 'sync', this.initAudioPlayer);
            /**
             * if 0 we filter by all projects
             */
            this.cur_project = 0;
        },

        onDestroy: function () {
            this.collection.off('sync', this.transform_collection, this);
        },

        onRender: function () {
            this.binding = app.Rivets.bind(this.el, {model: this.model});
            this.toggleCheckboxAutoCall();
            this.transform_collection(this.collection);
            this.initDropzone();
            this.$el.lptSetter();
        },

        _showError: function ( model, errors ) {
            for (var message in errors) {
                app.message.error(errors[message]);
            }
        },

        modelSave: function () {
            var changeList = this.model.changed;
            var changeIsActive = changeList.is_active;
            var nameProject = app.Models.curProject.get('name');
            if (this.model.isValid(true)) {
                this.model.save(changeList, {patch: true});

                if (!_.isUndefined(changeIsActive) && changeIsActive === true) {
                    app.message.success('Включен автоперезвон в проекте ' + nameProject);
                } else if (!_.isUndefined(changeIsActive) && changeIsActive === false) {
                    app.message.success('Выключен автоперезвон в проекте ' + nameProject);
                } else {
                    app.message.success(
                        'Настройки автоперезвона сохранены для проекта ' +
                        app.Models.curProject.get('name')
                    );
                }
            }
        },

        toggleCheckboxAutoCall: function () {
            var isChecked = this.ui.activateCheckbox.is(':checked');
            var isActive = this.ui.slideWrap.hasClass('active');

            if (isChecked && !isActive) {
                this.ui.slideWrap.addClass('active');
                this.ui.missedCallsRegion.addClass('missed-calls_small');
                this.initAudioPlayer();
            } else {
                this.ui.slideWrap.removeClass('active');
                this.ui.missedCallsRegion.removeClass('missed-calls_small');
            }
        },

        initAudioPlayer: function () {
            var urlMelody = this.model.get('greeting_listen');

            if (urlMelody) {
                this.regionAudioPlay.show(new AudioPlayer({model: this.model}));
            }
        },

        initDropzone: function () {
            var that = this;
            var curProjectId = app.Models.curProject.get('id');
            this.ui.getWelcomeSongBtn.dropzone(
                {
                    previewsContainer: false,
                    url: AppConfig.host + '/rest/dialer/auto-recall-config/greeting?project_id=' + curProjectId,
                    sending: function () {
                        app.message.success('Передаем файл');
                    },
                    complete: function ( jqXHR ) {
                        var xhr = jqXHR.xhr;

                        if (xhr.status === 200) {
                            app.message.success(
                                'Новое приветствие установлено'
                            );
                            that.model.fetch();
                        } else {
                            if (xhr.responseText !== undefined) {
                                var response = $.parseJSON(xhr.responseText);

                                app.message.error(response.message);
                            }
                        }
                    }
                }
            );
        },

        audioPlayPause: function () {
            this.model.trigger('playPause', this.ui.audioPlayPause);
        },

        /**
         * transfer collection to array to export on template
         */
        transform_collection: function ( collection ) {
            var that = this;
            var items = {};
            var storedCollapse = JSON.parse(app.storage.read('lptMissedCallsCollapse_' + app.Models.User.id)) || {};

            if (collection.length > 0) {
                collection.each(function(model) {
                    var project_id, project_name, project;

                    if (that.cur_project == 0) {
                        project_id = model.get('project_id');
                        project = app.Collections.Projects.get(project_id);
                        if (project) {
                            project_name = project.get('name');
                        }
                    } else {
                        project_id = that.cur_project;
                        if (model.get('project_id') === that.cur_project) {
                            project = app.Collections.Projects.get(that.cur_project);
                            if (project) {
                                project_name = project.get('name');
                            }
                        }
                    }

                    if (project_id && project_name) {
                        if (typeof items[project_id] == 'undefined') {
                            items[project_id] = {
                                name: project_name,
                                collapsed: !!storedCollapse[project_id],
                                items: []
                            }
                        }

                        items[project_id].items.push({
                            id: model.get('id'),
                            call_type: model.get('call_type'),
                            date: model.get('date'),
                            number: model.get('number'),
                            contact_name: model.get('contact_name'),
                            contact_id: model.get('contact_id'),
                            project_id: model.get('project_id')
                        });
                    }
                });
                that.showMissedCalls(items);
                this.$('.scrollbar-macosx').scrollbar();
            } else {
                that.showEmptyMissedCalls();
            }
        },

        showMissedCalls: function ( items ) {
            this.showChildView('regionMissedCalls', new MissedCallsList({items: items}));
            this.$('.scrollbar-macosx').scrollbar();
            this.$el.lptSetter();
        },

        showEmptyMissedCalls: function () {
            this.regionMissedCalls.show(new EmptyView());
        },

        /**
         * removing single alert
         */
        deleteCall: function ( e ) {
            var that = this;
            var id = $(e.currentTarget).data('id');
            var model = this.collection.get(id);

            e.stopPropagation();
            Backbone.ajax({
                url: AppConfig.host + '/rest/missed-calls',
                contentType: 'application/json',
                dataType: 'JSON',
                type: 'DELETE',
                data: JSON.stringify({
                    id: id
                }),
                success: function ( response ) {
                    if (response.status == 1 && !that.isDestroyed) {
                        $(e.currentTarget).closest('.b-notice__block').remove();
                        that.$('.js-collapse-project[data-project-id=' + model.get('project_id') + '] .b-chat__label').text(that.$('.js-collapse-project[data-project-id=' + model.get('project_id') + '] .b-chat__label').text() - 1);
                        that.collection.remove(model);
                        //that.transform_collection(that.collection);
                        app.Vents.trigger('miss_calls:delete');
                    }
                }
            });
        },

        /**
         * hide or show alerts
         */
        collapseProject: function ( e ) {
            var target = $(e.currentTarget);
            var projectId = target.data('project-id');
            var storedCollapse = JSON.parse(app.storage.read('lptMissedCallsCollapse_' + app.Models.User.id)) || {};

            target.children('span').toggle();
            this.$('.b-notice__block[data-project-id=' + projectId + ']').toggle();
            storedCollapse[projectId] = !storedCollapse[projectId];
            app.storage.write('lptMissedCallsCollapse_' + app.Models.User.id, JSON.stringify(storedCollapse));
        },

        /**
         * remove all alerts
         */
        clearAll: function () {
            var that = this;

            Backbone.ajax({
                url: AppConfig.host + '/rest/contacts/all-missed-calls',
                dataType: 'JSON',
                type: 'DELETE',
                data: JSON.stringify({
                    site_id: this.cur_project
                }),

                success: function ( response ) {
                    if (response.status == 1 && !that.isDestroyed) {
                        that.$('.b-mc__body').addClass('animated fadeOutRight');
                        app.message.success('Список пропущенных звонков очищен.');
                        app.Vents.trigger('miss_calls:delete');
                    }
                }
            });
        },

        /**
         * filter by all projects
         */
        allProjects: function () {
            this.$('.js-all-projects').addClass('active');
            this.$('.js-single-project').removeClass('active');

            this.cur_project = 0;

            this.transform_collection(this.collection);
        },

        /**
         * filter by single project
         */
        singleProject: function () {
            this.$('.js-single-project').addClass('active');
            this.$('.js-all-projects').removeClass('active');

            this.cur_project = app.Models.curProject.get('id');

            this.transform_collection(this.collection);
        },

        stopBubling: function ( event ) {
            event.stopPropagation();
        },

        onPressPhoneCall: function ( event ) {
            var that = this;
            var startTime = Date.now();
            var target = event.currentTarget;
            var timeout = setTimeout(function () {
                var handler = function ( widget ) {
                    that.listenToOnce(widget, 'employee:selected', function ( data ) {
                        that.phoneCall.call(that, event, data.employee, data.type);
                    });
                };
                that.triggerMethod('showPopover', {
                    view: StaffCallContactPopover,
                    target: target,
                    handler: handler
                });
            }, 1000);
            event.stopPropagation();
            event.preventDefault();
            $(event.currentTarget).one('mouseup', function ( e ) {
                event.stopPropagation();
                var stopTime = Date.now();
                var duration = stopTime - startTime;
                if (duration <= 1000) {
                    clearTimeout(timeout);
                    that.phoneCall.call(that, event);
                }
            });
        },

        phoneCall: function ( e, employee, type ) {
            e.stopPropagation();
            e.preventDefault();

            var that = this;
            var target = $(e.currentTarget);
            var id = target.data('id');
            var missCall = this.collection.get(id);
            var number = missCall && missCall.get('number');
            var callType;
            var data;

            if (type !== undefined) {
                callType = type;
            } else if (app.Models.User.get('calls_to_sip')) {
                callType = 0;
            } else if (app.Models.User.get('calls_to_mobile')) {
                callType = 1;
            } else if (app.Models.User.get('calls_to_sim')) {
                callType = 2;
            }

            data = {
                call_type: callType,
                phone: number
            };

            if (employee) {
                data.user_id = employee.id;
                data.user_type = employee.get('profile_type');
            }

            app.checkCallTime('phone', data.phone, function(){
                Backbone.ajax({
                    url: AppConfig.host + '/rest/contacts/call_to_number',
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    success: function ( response ) {
                        if (~~response.status === 1) {
                            if (!employee) {
                                app.message.success(response.message);
                            } else {
                                app.message.success('Звонок отправлен сотруднику');
                            }
                        } else {
                            app.message.error(response.message);
                        }
                    },
                    error: function ( xhr ) {
                        var response = $.parseJSON(xhr.responseText);
                        app.message.error(response.message || 'Ошибка');
                    }
                });
            });
        },

        callToPhone: function ( options ) {
            var that = this;
            var input = $('#js-call_to_phone');
            /**
             * @type {string}
             */
            var phone = $(input).val();
            var id = $(input).data('contact_id');
            var call_type = options.type;

            var byContact = phone.indexOf('*') != -1 && id > 0;

            var method = byContact ? 'call' : 'call_to_number';
            var data = {
                call_type: call_type
            };

            if (byContact) {
                data.phone_id = id;
            } else {
                data.phone = phone;
            }

            Backbone.ajax({
                type: 'POST',
                url: AppConfig.host + '/rest/contacts/' + method,
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: function ( response ) {
                    if (response.status == AppConfig.STATUS_OK) {
                        app.message.success(response.message);
                    } else {
                        app.message.error(response.message);
                    }
                },
                error: function ( xhr ) {
                    var response = $.parseJSON(xhr.responseText);
                    app.message.error(response.message || 'Ошибка');
                }
            });
        },

        onClickSendSms: function ( event ) {
            var that = this;
            var target = $(event.currentTarget);
            var id = '' + target.data('contactId');
            event.stopPropagation();
            this.triggerMethod('showPopover', {
                view: SmsEditPopover,
                target: target,
                handler: function ( widget ) {
                    that.listenToOnce(widget, 'sms:edited', function ( message ) {
                        var data = {
                            contact_ids: id,
                            text: message
                        };
                        that.sendSms.call(that, data);
                    });
                }
            });
        },

        onClickSendEmail: function ( event ) {
            var that = this;
            var target = $(event.currentTarget);
            var model = new EmailModel();
            var id = '' + target.data('contactId');
            event.stopPropagation();
            var dialog = new EmailEditPopover({
                curElement: $(target),
                modalData: {
                    model: model
                }
            });
            this.triggerMethod('showModal', dialog);
            this.listenToOnce(dialog, 'email:edited', function (isHtml) {
                var data = {
                    contact_ids: id,
                    subject: model.get('subject'),
                    text: model.get('text'),
                    type: isHtml ? 'html' : 'text'
                };
                if (model.get('from')) {
                    data.from = model.get('from');
                }
                that.sendEmail.call(that, data);
            });
        },

        sendSms: function ( data ) {
            if (data.contact_ids.length) {
                var msg = app.message.success('Отправка Sms', false);
                this._xhr = Backbone.ajax({
                    url: AppConfig.host + '/rest/contacts/sms',
                    contentType: 'application/json',
                    type: 'POST',
                    data: JSON.stringify(data),
                    success: function ( response ) {
                        msg.hide();
                    },
                    error: function ( xhr ) {
                        var data = xhr.responseJSON;
                        app.message.error(data.message);
                    }
                });
            } else {
                app.message.error('Нет выбранных номеров');
            }
        }
    });
});
